import * as React from 'react';
import FormView from '../../FormView/index';
import SummaryPanel from '../SummaryPanel/index';
import { IWhereUsedProps } from '../interfaces';

class WhereUsed extends React.PureComponent<IWhereUsedProps> {
  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    const context = 'inventory-enquiry';
    if (path) {
      switch (path) {
        case `/${context}/where-used/bill-of-material`:
          onInitialLoad('WhereUsedBOM');
          break;
        case `/${context}/where-used/catalogue`:
          onInitialLoad('WhereUsedCatalogue');
          break;
        default:
          onInitialLoad('WhereUsedBOM');
      }
    }
  }

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedForm, operationMode, selectedTab } = this.props;

    return (selectedForm &&
      <React.Fragment>
        <SummaryPanel
          variant={'ProductDetails'}
        />
        <FormView
          formName={selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          includeTabsHeight={false}
          schema={selectedForm}
          initialValues={null}
          operationMode={operationMode}
          enableReinitialize={true}
          valuesSchema={null}
        />
      </React.Fragment>
    );
  }
}

export default WhereUsed;
